import { motion } from 'framer-motion';
import { styled } from 'styled-components';

interface StyledSpinnerContainerProps {
  width: string;
  height: string;
}

export const StyledSpinnerContainer = styled(motion.div)`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const StyledSpinnerCircle = styled(motion.div)<StyledSpinnerContainerProps>`
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  margin: 6px;
  border-style: solid;
  border-radius: 50%;
  animation: spin 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
`;
